export class OriginalType {
  static get CustomerItem () {
    return 1
  }
  static get ErpItem () {
    return 2
  }
  static get Customize () {
    return 10
  }

  static getOriginalTypeName (originalType) {
    let name = ''
    switch (originalType) {
      case 1:
        name = '單價明細表-單品項'
        break
      case 2:
        name = 'ERP-品號作業'
        break
      case 10:
        name = '自訂'
        break
    }
    return name
  }
}
